// Image paths from public/images directory
export const fish_thorny = "/images/fish_thorny.svg";
export const lilo_logo = "/images/lilo_logo.svg";
export const search_icon = "/images/search_icon.svg";
export const fish_wood = "/images/fish_wood.svg";
export const fishmaid_logo = "/images/Fishmaid.svg";
export const ellipse = "/images/Ellipse .svg";
export const profile_Icon = "/images/profile_Icon.svg";
export const location_Icon = "/images/location_Icon.svg";
export const cart_Icon = "/images/cart_Icon.svg";
export const banner = "/images/banner.svg";
export const bggreen = "/images/bggreen.svg";
export const hook_Img = "/images/hook_Img.svg";
export const seaFish = "/images/seaFish.png";
export const shellFish = "/images/shellFish.png";
export const freshWaterFish = "/images/freshWaterFish.png";
export const comboFish = "/images/comboFish.png";
export const liveLocal_Logo = "/images/liveLocal_logo_img.svg";
export const dropdown_icon = "/images/dropdown_icon.svg";
export const lilo_logo_02 = "/images/lilo_logo_02.svg";
export const play_store = "/images/play_store.svg";
export const app_store = "/images/app_store.svg";
export const home_icon = "/images/home.svg";
export const work_icon = "/images/work.svg";
export const location_pin = "/images/location_pin.svg";
export const double_arrow = "/images/double_arrow.svg";
export const hotel_icon = "/images/hotel_icon.svg";
export const CategoryImageicon = "/images/CategoryImageicon.svg";
export const previousordericon = "/images/previousordericon.svg";
export const Bestpickersicon = "/images/Bestpickersicon.svg";
export const homepagefishimg = "/images/homepagefishimg.svg";
export const instagramicon = "/images/instagramicon.svg";
export const facebookicon = "/images/facebookicon.svg";
export const youtubeicon = "/images/youtubeicon.svg";
export const playstore = "/images/playstore.svg";
export const appstoreicon = "/images/appstoreicon.svg";
export const Pre_demo_img = "/images/fish_demo.svg";
export const cart_trolly = "/images/cart_trolly.svg";
export const squid_fish = "/images/squid_fish.svg";
export const prawns_fish = "/images/prawns_fish.svg";
export const king_fish = "/images/king_fish.svg";
export const tuna_fish = "/images/tuna_fish.svg";
export const companyicons = "/images/companyicons.svg";
export const SpecialOfferIcon = "/images/SpecialOfferIcon.svg";
export const GPSCalibration = "/images/GPSCalibration.gif";
export const succesicon = "/images/succesicon.svg";
export const Erroricon = "/images/Erroricon.svg";
export const Bucket = "/images/Bucket.png";
export const calenderIcon = "/images/calenderIcon.svg";
export const CartIcon = "/images/Cart.svg";
export const availableoffers = "/images/availableOffers.svg";
export const foodIcon = "/images/foodIcon.svg";
export const rectangleGreen = "/images/rectangleGreen.svg";
export const rectangles = "/images/CategoryImage.svg";
export const share = "/images/share.svg";
export const fssailogo = "/images/fssailogo.svg";
export const image_home_page = "/images/image_home_page.png";
export const leaf_image_small = "/images/leaf_image_smal.svg";
export const fish_demo = "/images/fish_demo.svg";
export const meat_demo = "/images/meat_demo.png";
export const meat_merchant = "/images/meatPlaceHolder.png";
